import script from "./StudiesOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./StudiesOverview.vue?vue&type=script&setup=true&lang=js"

import "./StudiesOverview.vue?vue&type=style&index=0&id=75952de4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75952de4"]])

export default __exports__